import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import arrowIcon from '@/assets/images/btn-menu-arrow-down.png'

// Lib MISC
import styles from './style.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'danger', 'light']),
  isFilled: PropTypes.bool,
  elementType: PropTypes.string,
}

const defaultProps = {
  type: 'primary',
  isFilled: true,
  elementType: 'dropdown',
}

function DropDown (props) {
  const { className, children, type, isFilled, elementType, headIcon, handleSelect, value, list, ...restProps } = props
  const [isOpened, setIsOpened] = useState(false)
  const handleClick = (item) => {
    handleSelect(item)
    setIsOpened(false)
  }
  return (
    <div className={cx('dropdown-wrapper')}>
      <button
        className={cx('dropdown', className)}
        data-type={type}
        data-is-filled={isFilled}
        type={elementType}
        onClick={() => setIsOpened(!isOpened)}
        data-active={isOpened}
        {...restProps}>
        {headIcon && <img className={cx('dropdown-icon')} src={headIcon} />}
        {value}
        <img className={cx('dropdown-icon')} src={arrowIcon} />
      </button>
      {
        isOpened && <div className={cx('dropdown-list')}>
          {list.map((item) =>
            <div
              className={cx('dropdown-list-items')}
              onClick={() => handleClick(item)}
              key={item.key}
            >
              {item.name}
            </div>
          )}
        </div>
      }
    </div >
  )
}

DropDown.propTypes = propTypes
DropDown.defaultProps = defaultProps

export default DropDown
